import { Component, EventEmitter, Input, Output } from '@angular/core';

/** A small, accessible file picker that keeps native file handling in its parent. */
@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  @Input() accept = '';
  @Input() multiple = false;
  @Input() label = 'Upload file';
  @Input() disabled = false;
  @Output() fileSelected = new EventEmitter<Event>();

  onFileSelected(event: Event): void {
    this.fileSelected.emit(event);
  }
}
